import React, { FC } from "react";
import Input from "antd/lib/input/Input";
import user from "../../../assets/user.png";
import { SearchOutlined } from "@ant-design/icons";
import "../../../styles/user.scss";
import UserValidationTable from "./tables/UserValidationTable";
const UserValidation: FC = () => {
  return (
    <div className="user">
      <div className="user__header">
        {/* <div className="user__header-row">
          <div>
            <Input
              size="large"
              placeholder="Search all.."
              prefix={<SearchOutlined />}
              className="inp"
            />
          </div>
          <img src={user} alt="profile" className="profile" />
        </div> */}
      </div>
      <div className="user__top">
        <div className="user__top-btn">
          {/* <Link to="/edit-user-profile"> */}
          <button className="dels">
            <svg
              width="19"
              height="21"
              viewBox="0 0 19 21"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.5 0.375C10.3301 0.374946 11.1288 0.692554 11.7322 1.26267C12.3356 1.83279 12.698 2.61219 12.745 3.441L12.75 3.625H18C18.19 3.62506 18.3729 3.69724 18.5118 3.82697C18.6506 3.9567 18.7351 4.1343 18.748 4.32388C18.761 4.51346 18.7015 4.70089 18.5816 4.8483C18.4617 4.99571 18.2902 5.0921 18.102 5.118L18 5.125H17.204L15.924 18.145C15.8599 18.7941 15.5671 19.3993 15.098 19.8525C14.6289 20.3056 14.0139 20.5773 13.363 20.619L13.187 20.625H5.813C5.16046 20.625 4.52919 20.3929 4.03201 19.9703C3.53482 19.5477 3.20412 18.962 3.099 18.318L3.076 18.144L1.795 5.125H1C0.818762 5.12499 0.643658 5.05936 0.507069 4.94023C0.370481 4.82111 0.281648 4.65655 0.257 4.477L0.25 4.375C0.250008 4.19376 0.315643 4.01866 0.434767 3.88207C0.553891 3.74548 0.718446 3.65665 0.898 3.632L1 3.625H6.25C6.25 2.76305 6.59241 1.9364 7.2019 1.3269C7.8114 0.71741 8.63805 0.375 9.5 0.375ZM15.697 5.125H3.302L4.569 17.997C4.59705 18.2842 4.72362 18.5529 4.92722 18.7574C5.13082 18.9619 5.39892 19.0897 5.686 19.119L5.813 19.125H13.187C13.787 19.125 14.296 18.7 14.412 18.123L14.432 17.997L15.696 5.125H15.697ZM11.25 7.875C11.4312 7.87501 11.6063 7.94064 11.7429 8.05977C11.8795 8.17889 11.9684 8.34345 11.993 8.523L12 8.625V15.625C11.9999 15.815 11.9278 15.9979 11.798 16.1368C11.6683 16.2756 11.4907 16.3601 11.3011 16.373C11.1115 16.386 10.9241 16.3265 10.7767 16.2066C10.6293 16.0867 10.5329 15.9152 10.507 15.727L10.5 15.625V8.625C10.5 8.42609 10.579 8.23532 10.7197 8.09467C10.8603 7.95402 11.0511 7.875 11.25 7.875ZM7.75 7.875C7.93124 7.87501 8.10634 7.94064 8.24293 8.05977C8.37952 8.17889 8.46835 8.34345 8.493 8.523L8.5 8.625V15.625C8.49994 15.815 8.42776 15.9979 8.29803 16.1368C8.1683 16.2756 7.9907 16.3601 7.80112 16.373C7.61154 16.386 7.42411 16.3265 7.2767 16.2066C7.12929 16.0867 7.0329 15.9152 7.007 15.727L7 15.625V8.625C7 8.42609 7.07902 8.23532 7.21967 8.09467C7.36032 7.95402 7.55109 7.875 7.75 7.875ZM9.5 1.875C9.06081 1.87502 8.63768 2.04017 8.31461 2.33768C7.99154 2.63519 7.79214 3.0433 7.756 3.481L7.75 3.625H11.25C11.25 3.16087 11.0656 2.71575 10.7374 2.38756C10.4092 2.05937 9.96413 1.875 9.5 1.875Z"
                fill="#666666"
              />
            </svg>
            Delete
          </button>
          {/* </Link> */}
        </div>
        <div className="user__top-filter">
          {/* <Link to="/add-user">
            <button className="dell">Add User</button>
          </Link> */}
          <button className="dll">
            <svg
              width="16"
              height="15"
              viewBox="0 0 16 15"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14.7962 0H1.20394C0.579391 0 0.264245 0.757793 0.706774 1.20032L6.125 6.61936V12.6562C6.125 12.8857 6.23694 13.1007 6.42491 13.2323L8.76866 14.8723C9.23105 15.196 9.87499 14.868 9.87499 14.2963V6.61936L15.2934 1.20032C15.735 0.758672 15.422 0 14.7962 0Z"
                fill="#666666"
              />
            </svg>
            Filter
          </button>
        </div>
      </div>
      <div>
        <UserValidationTable />
      </div>
    </div>
  );
};
export default UserValidation;
